import React, { useEffect, useState } from 'react';

export const DateTimeHelper = (pickupDate, pickupTime) => {
  const combinedDateTime = `${pickupDate} ${pickupTime}`;
  const dateObj = new Date(combinedDateTime);

  return GetDateTimeString(dateObj)

}

export const CountdownTimer = ({ expiry, afterExpiryHandler }) => {
  // State to store the remaining time
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(expiry));

  // Calculate the remaining time
  function calculateTimeLeft(expiry) {
    const now = new Date().getTime();
    const distance = expiry * 1000 - now; // Convert expiry timestamp to milliseconds
    if (distance <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const newTimeLeft = calculateTimeLeft(expiry);
      setTimeLeft(newTimeLeft);
      if (newTimeLeft.days === 0 && newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
        clearInterval(interval);
        afterExpiryHandler();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [expiry]);

  return (
    <>
      {timeLeft.days > 0 ? timeLeft.days + 'd' : ''} {timeLeft.hours > 0 ? timeLeft.hours + "h" : ""} {timeLeft.minutes > 0 ? timeLeft.minutes + "m" : ""} {timeLeft.seconds > 0 ? timeLeft.seconds + "s" : ""}
    </>
  );
};


export const GetDateTimeString = (dateObj) => {
  const options = {
    weekday: 'short',  // 'Sat'
    year: 'numeric',   // '2025'
    month: 'short',    // 'Dec'
    day: 'numeric',    // '21'
    hour: '2-digit',   // '10'
    minute: '2-digit', // '00'
    hour12: true,      // AM/PM format
  };

  const formattedDateTime = dateObj.toLocaleString('en-GB', options);
  return formattedDateTime
}